/**
 * CUSTOM CONVERSION CART DRAWER ENGINE (Horizon Edition)
 * Fixed Native Horizon Bubble Integration + Instant Sync
 */
(function () {
  const CartDrawer = {
    drawer: null,
    timerInterval: null,
    discountCodes: {
      tier1: 'SAVE10', // 2 items = 10%
      tier2: 'SAVE15', // 3 items = 15%
      tier3: 'SAVE20', // 4 items = 20%
      tier4: 'SAVE25'  // 5+ items = 25%
    },

    init() {
      this.drawer = document.getElementById('CustomCartDrawer');
      if (!this.drawer) return;

      this.bindEvents();
      this.ensureTimerRunning();
      this.refreshCartState();
      this.fetchCart().then(cart => this.updateHorizonBubble(cart.item_count));
    },

    bindEvents() {
      // 1. Abrir / Fechar gaveta
      document.addEventListener('cart:open', () => this.open());
      document.addEventListener('click', (e) => {
        if (e.target.closest('[data-cart-close]')) this.close();
      });

      // 2. Intercetar o ícone do carrinho no cabeçalho do Horizon
      window.addEventListener('click', (e) => {
        const trigger = e.target.closest(
          'a[href*="/cart"], .action__cart, [data-testid="cart-drawer-trigger"], [data-testid="cart-icon"], button[on\\:click*="cart-drawer"], cart-icon, .header-actions__cart-icon'
        );
        if (trigger) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          this.open();
        }
      }, true);

      // 3. Intercetar envio de "Add to Cart" no produto
      window.addEventListener('submit', async (e) => {
        const form = e.target.closest('form[action*="/cart/add"]');
        if (!form) return;

        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        const submitBtn = form.querySelector('[type="submit"], [name="add"], .product-form__submit, button[name="add"]');
        let originalBtnHtml = '';
        if (submitBtn) {
          originalBtnHtml = submitBtn.innerHTML;
          submitBtn.classList.add('custom-atc-loading');
          submitBtn.innerHTML = '<span class="checkout-btn-spinner" style="display:inline-block !important;"></span>';
          submitBtn.disabled = true;
        }

        try {
          const formData = new FormData(form);
          await fetch('/cart/add.js', { method: 'POST', body: formData });

          if (!sessionStorage.getItem('customCartTimerStart')) {
            sessionStorage.setItem('customCartTimerStart', Date.now().toString());
          }

          await this.renderUpdatedDrawer();
          this.open();
        } catch (err) {
          console.error('Error adding item to cart:', err);
        } finally {
          if (submitBtn) {
            submitBtn.innerHTML = originalBtnHtml;
            submitBtn.classList.remove('custom-atc-loading');
            submitBtn.disabled = false;
          }
        }
      }, true);

      // 4. Spinner no clique do botão Checkout
      document.addEventListener('click', (e) => {
        const checkoutBtn = e.target.closest('[data-checkout-btn]');
        if (checkoutBtn) {
          checkoutBtn.classList.add('is-loading');
        }
      });

      // 5. Ajuste de quantidade (+ / -)
      document.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-qty-action]');
        if (!btn) return;

        btn.classList.add('is-loading');
        this.setPanelUpdating(true);

        const action = btn.dataset.qtyAction;
        const key = btn.dataset.key;
        const qtyBox = btn.closest('[data-qty-box]');
        const numElem = qtyBox.querySelector('.qty-num');
        const currentQty = parseInt(numElem.textContent, 10);
        const newQty = action === 'plus' ? currentQty + 1 : Math.max(0, currentQty - 1);
        this.updateItem(key, newQty);
      });

      // 6. Remover produto
      document.addEventListener('click', (e) => {
        const removeBtn = e.target.closest('[data-remove-key]');
        if (!removeBtn) return;

        removeBtn.classList.add('is-loading');
        this.setPanelUpdating(true);
        const key = removeBtn.dataset.removeKey;
        this.updateItem(key, 0);
      });

      // 7. Mudança de Variante por Seletores
      document.addEventListener('change', async (e) => {
        const select = e.target.closest('.custom-cart-item__opt-select');
        if (!select) return;

        this.setPanelUpdating(true);
        const itemContainer = select.closest('.custom-cart-item');
        const variantsData = JSON.parse(itemContainer.dataset.productVariants);
        const key = select.dataset.itemKey;

        const selects = itemContainer.querySelectorAll('.custom-cart-item__opt-select');
        const selectedOptions = Array.from(selects).map(s => s.value);

        const matchingVariant = variantsData.find(v => {
          return selectedOptions.every((val, idx) => v.options[idx] === val);
        });

        if (matchingVariant) {
          const qty = parseInt(itemContainer.querySelector('.qty-num').textContent, 10);
          await this.switchVariant(key, matchingVariant.id, qty);
        } else {
          this.setPanelUpdating(false);
        }
      });
    },

    open() {
      this.drawer.classList.add('is-active');
      this.drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    },

    close() {
      this.drawer.classList.remove('is-active');
      this.drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    },

    setPanelUpdating(isUpdating) {
      const panel = this.drawer.querySelector('[data-drawer-panel]');
      if (panel) {
        if (isUpdating) {
          panel.classList.add('is-updating');
        } else {
          panel.classList.remove('is-updating');
        }
      }
    },

    formatMoney(cents) {
      const value = (cents / 100).toFixed(2);
      return '£' + value;
    },

    // Sincronização nativa direta com o Horizon
    updateHorizonBubble(count) {
      const num = parseInt(count, 10) || 0;

      // 1. Atualizar o contador no título do drawer
      if (this.drawer) {
        const drawerTitleCount = this.drawer.querySelector('[data-cart-count]');
        if (drawerTitleCount) drawerTitleCount.textContent = num;
      }

      // 2. Chamar o método oficial do componente Horizon se estiver disponível
      document.querySelectorAll('cart-icon').forEach(cartIcon => {
        if (typeof cartIcon.renderCartBubble === 'function') {
          cartIcon.renderCartBubble(num, false);
        }
      });

      // 3. Garantir a remoção forçada das classes visually-hidden e hidden do Horizon
      document.querySelectorAll('cart-icon, .header-actions__cart-icon').forEach(cartIcon => {
        const bubble = cartIcon.querySelector('.cart-bubble');
        const countEl = cartIcon.querySelector('.cart-bubble__text-count, [ref="cartBubbleCount"], [data-testid="cart-bubble"]');

        if (num > 0) {
          cartIcon.classList.add('header-actions__cart-icon--has-cart');
          
          if (bubble) {
            bubble.classList.remove('visually-hidden', 'hidden', 'hide');
            bubble.removeAttribute('hidden');
            bubble.style.removeProperty('display');
          }

          if (countEl) {
            countEl.classList.remove('hidden', 'hide');
            countEl.textContent = num;
          }
        } else {
          cartIcon.classList.remove('header-actions__cart-icon--has-cart');
          if (bubble) {
            bubble.classList.add('visually-hidden');
          }
          if (countEl) {
            countEl.classList.add('hidden');
            countEl.textContent = '';
          }
        }
      });
    },

    async fetchCart() {
      const res = await fetch('/cart.js');
      return await res.json();
    },

    async renderUpdatedDrawer() {
      try {
        const res = await fetch(`${window.location.pathname}?sections=custom-cart-drawer`);
        const data = await res.json();
        const htmlString = data['custom-cart-drawer'];

        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlString, 'text/html');

        const oldBody = this.drawer.querySelector('[data-cart-items-container]');
        const newBody = doc.querySelector('[data-cart-items-container]');
        if (oldBody && newBody) oldBody.innerHTML = newBody.innerHTML;

        const oldFooter = this.drawer.querySelector('.custom-cart-drawer__footer');
        const newFooter = doc.querySelector('.custom-cart-drawer__footer');
        const panel = this.drawer.querySelector('[data-drawer-panel]');
        if (oldFooter && newFooter) {
          oldFooter.innerHTML = newFooter.innerHTML;
        } else if (!oldFooter && newFooter && panel) {
          panel.appendChild(newFooter);
        } else if (oldFooter && !newFooter) {
          oldFooter.remove();
        }

        const cart = await this.fetchCart();
        this.updateHorizonBubble(cart.item_count);
        this.ensureTimerRunning(cart.item_count);
        await this.refreshCartState(cart);
      } catch (err) {
        console.error('Error rendering drawer:', err);
      } finally {
        this.setPanelUpdating(false);
      }
    },

    async updateItem(key, quantity) {
      try {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: quantity })
        });
        await this.renderUpdatedDrawer();
      } catch (err) {
        console.error('Error updating cart item:', err);
        this.setPanelUpdating(false);
      }
    },

    async switchVariant(oldKey, newVariantId, quantity) {
      try {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: oldKey, quantity: 0 })
        });

        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: newVariantId, quantity: quantity })
        });

        await this.renderUpdatedDrawer();
      } catch (err) {
        console.error('Error switching variant:', err);
        this.setPanelUpdating(false);
      }
    },

    async refreshCartState(optionalCart) {
      const cart = optionalCart || await this.fetchCart();
      const itemCount = cart.item_count;
      const subtotalInCents = cart.original_total_price || cart.total_price;

      // 1. Ler configurações e códigos dinâmicos definidos no Tema
      const discountsEnabled = this.drawer.dataset.enableDiscounts === 'true';
      const showProgressBar = this.drawer.dataset.showProgressBar === 'true';

      const discountCodes = {
        tier1: this.drawer.dataset.codeTier1 || 'SAVE10',
        tier2: this.drawer.dataset.codeTier2 || 'SAVE15',
        tier3: this.drawer.dataset.codeTier3 || 'SAVE20',
        tier4: this.drawer.dataset.codeTier4 || 'SAVE25'
      };

      const progressWrap = this.drawer.querySelector('[data-discount-progress-wrap]');
      const timerWrap = this.drawer.querySelector('[data-cart-timer-wrap]');
      const trustBadgesWrap = this.drawer.querySelector('[data-trust-badges-wrap]');

      // Visibilidade dinâmica
      if (progressWrap) {
        progressWrap.style.setProperty('display', (showProgressBar && itemCount > 0) ? 'block' : 'none', 'important');
      }
      if (timerWrap) timerWrap.style.setProperty('display', itemCount > 0 ? 'block' : 'none', 'important');
      if (trustBadgesWrap) trustBadgesWrap.style.setProperty('display', itemCount > 0 ? 'flex' : 'none', 'important');

      // Poupança face ao preço original (Compare At Price)
      const itemsInDrawer = this.drawer.querySelectorAll('.custom-cart-item');
      let domCatalogSavingsInCents = 0;
      itemsInDrawer.forEach(it => {
        const compEl = it.querySelector('.custom-cart-item__compare-price');
        const priceEl = it.querySelector('.custom-cart-item__price');
        const qtyEl = it.querySelector('.qty-num');
        if (compEl && priceEl && qtyEl) {
          const compVal = parseFloat(compEl.textContent.replace(/[^0-9.]/g, ''));
          const priceVal = parseFloat(priceEl.textContent.replace(/[^0-9.]/g, ''));
          const qty = parseInt(qtyEl.textContent, 10);
          if (!isNaN(compVal) && !isNaN(priceVal) && compVal > priceVal) {
            domCatalogSavingsInCents += Math.round((compVal - priceVal) * 100) * qty;
          }
        }
      });

      // 2. Escalões de Desconto (apenas calculados se discountsEnabled estiver ativo)
      let discountPercent = 0;
      let activeCode = '';
      let progressPercent = 0;
      let statusMsg = '';

      if (discountsEnabled) {
        if (itemCount === 0) {
          progressPercent = 0;
          statusMsg = 'Add 2 items to unlock 10% OFF!';
        } else if (itemCount === 1) {
          progressPercent = 12.5;
          statusMsg = 'Add <strong>1 more item</strong> for <strong>10% OFF</strong>!';
        } else if (itemCount === 2) {
          discountPercent = 10;
          activeCode = discountCodes.tier1;
          progressPercent = 25;
          statusMsg = '<strong>10% OFF</strong> unlocked! Add <strong>1 more</strong> for <strong>15% OFF</strong>!';
        } else if (itemCount === 3) {
          discountPercent = 15;
          activeCode = discountCodes.tier2;
          progressPercent = 50;
          statusMsg = '<strong>15% OFF</strong> unlocked! Add <strong>1 more</strong> for <strong>20% OFF</strong>!';
        } else if (itemCount === 4) {
          discountPercent = 20;
          activeCode = discountCodes.tier3;
          progressPercent = 75;
          statusMsg = '<strong>20% OFF</strong> unlocked! Add <strong>1 more</strong> for <strong>25% OFF</strong>!';
        } else if (itemCount >= 5) {
          discountPercent = 25;
          activeCode = discountCodes.tier4;
          progressPercent = 100;
          statusMsg = 'Congratulations! Maximum <strong>25% discount unlocked</strong>!';
        }
      }

      // Atualiza a barra gráfica apenas se estiver ativa
      if (showProgressBar && progressWrap) {
        const fill = this.drawer.querySelector('[data-discount-progress-fill]');
        const textElem = this.drawer.querySelector('[data-discount-progress-text]');
        if (fill) fill.style.width = progressPercent + '%';
        if (textElem) textElem.innerHTML = statusMsg;

        const nodes = this.drawer.querySelectorAll('.progress-node');
        nodes.forEach((nd, idx) => {
          if (itemCount >= idx + 2) {
            nd.classList.add('is-reached');
          } else {
            nd.classList.remove('is-reached');
          }
        });
      }

      // 3. Aplicação do desconto nos totais e no botão Checkout
      const tieredSavingCents = (discountsEnabled && discountPercent > 0) ? Math.floor(subtotalInCents * discountPercent / 100) : 0;
      const totalSavingsCents = domCatalogSavingsInCents + tieredSavingCents;
      const finalCheckoutCents = subtotalInCents - tieredSavingCents;

      const discountRow = this.drawer.querySelector('[data-discount-row]');
      const discountBadge = this.drawer.querySelector('[data-discount-badge]');
      const discountPillText = this.drawer.querySelector('[data-discount-pill-text]');
      const totalDiscountAmount = this.drawer.querySelector('[data-total-discount-amount]');
      const checkoutTotalElem = this.drawer.querySelector('[data-checkout-total]');
      const checkoutBtn = this.drawer.querySelector('[data-checkout-btn]');

      if (checkoutTotalElem) checkoutTotalElem.textContent = this.formatMoney(finalCheckoutCents);

      if (totalSavingsCents > 0) {
        if (discountRow) discountRow.style.display = 'flex';
        if (totalDiscountAmount) totalDiscountAmount.textContent = '-' + this.formatMoney(totalSavingsCents);

        if (discountPercent > 0 && discountsEnabled) {
          if (discountBadge) discountBadge.style.display = 'inline-flex';
          if (discountPillText) discountPillText.textContent = `-${discountPercent}% (-${this.formatMoney(tieredSavingCents)})`;
          if (checkoutBtn) checkoutBtn.href = `/checkout?discount=${activeCode}`;
        } else {
          if (discountBadge) discountBadge.style.display = 'none';
          if (checkoutBtn) checkoutBtn.href = '/checkout';
        }
      } else {
        if (discountRow) discountRow.style.display = 'none';
        if (checkoutBtn) checkoutBtn.href = '/checkout';
      }
    },

    async ensureTimerRunning(count) {
      if (this.timerInterval) clearInterval(this.timerInterval);

      const cart = typeof count === 'number' ? { item_count: count } : await this.fetchCart();
      const timerDisplay = this.drawer.querySelector('[data-cart-timer]');
      const timerWrap = this.drawer.querySelector('[data-cart-timer-wrap]');

      if (cart.item_count === 0) {
        if (timerWrap) timerWrap.style.display = 'none';
        sessionStorage.removeItem('customCartTimerStart');
        return;
      }

      if (!sessionStorage.getItem('customCartTimerStart')) {
        sessionStorage.setItem('customCartTimerStart', Date.now().toString());
      }

      if (timerWrap) timerWrap.style.display = 'block';

      const startTime = parseInt(sessionStorage.getItem('customCartTimerStart'), 10);
      const totalDuration = 10 * 60 * 1000;

      const updateTimer = () => {
        const elapsed = Date.now() - startTime;
        const remaining = Math.max(0, totalDuration - elapsed);

        const totalSeconds = Math.floor(remaining / 1000);
        const mins = Math.floor(totalSeconds / 60);
        const secs = totalSeconds % 60;

        if (timerDisplay) {
          timerDisplay.textContent = 
            (mins < 10 ? '0' : '') + mins + ':' + 
            (secs < 10 ? '0' : '') + secs;
        }

        if (remaining <= 0) {
          clearInterval(this.timerInterval);
          sessionStorage.removeItem('customCartTimerStart');
          if (timerWrap) timerWrap.style.display = 'none';
        }
      };

      updateTimer();
      this.timerInterval = setInterval(updateTimer, 1000);
    }
  };

  document.addEventListener('DOMContentLoaded', () => CartDrawer.init());
})();